import { render } from "./Storage_process_button.vue?vue&type=template&id=e083b0a2&scoped=true"
import script from "./Storage_process_button.vue?vue&type=script&lang=js"
export * from "./Storage_process_button.vue?vue&type=script&lang=js"

import "./Storage_process_button.vue?vue&type=style&index=0&id=e083b0a2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e083b0a2"]])

export default __exports__